<template>
  <v-dialog v-model="showDialog" max-width="80%" :overlay-opacity="0.8">
    <v-img v-if="imageUrl" :src="imageUrl" contain />
  </v-dialog>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

export default mixins(DialogMixin).extend({
  name: 'PhotoViewer',

  props: {
    imageUrl: {
      type: String,
      default: null,
    }
  },
});
</script>
